// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"173":"detail-view","682":"restaurants-view","844":"favorite-view"}[chunkId] || chunkId) + "." + {"173":"a41a4307","495":"6d198cac","682":"af558043","844":"20810a86","883":"3e7d1ca3"}[chunkId] + ".chunk.js";
};